import instObj from '@/backend/axios-instances'

const resource = "/boms"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // need project_id as a parameter
    return instance.post(resource, data, { params: parameters });
  }
}
